import React from 'react';
import IndividualQuotationSummary from './IndividualQuotationSummary';
import { IndividualPricingQuote } from '../../../services/individualPricingQuotations';
export default function RetainedIndividualQuotation({ application }: { application: {loanType?: string; individualPricingQuoteSnapshot?: string} }) {
  if (application.loanType !== 'PERSONAL' || !application.individualPricingQuoteSnapshot) return null;
  try {
    const quote = JSON.parse(application.individualPricingQuoteSnapshot) as IndividualPricingQuote;
    if (!quote.quoteId || !quote.pricing?.versionId || !quote.funding || !Array.isArray(quote.instalments)) throw new Error('Invalid quotation');
    return <div className="card mb-3"><div className="card-body"><IndividualQuotationSummary quote={quote} /></div></div>;
  } catch { return <p role="alert">The retained quotation could not be displayed. Reload the application or report its reference.</p>; }
}
